import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_REIMBURSEMENTTYPE,
  DELETE_REIMBURSEMENTTYPE,
  UPDATE_REIMBURSEMENTTYPE,
  ADD_NEW_REIMBURSEMENTTYPE,
} from "./actionType";

import {
  getReimbursementTypeSuccess,
  getReimbursementTypeFail,
  deleteReimbursementTypeSuccess,
  deleteReimbursementTypeFail,
  updateReimbursementTypeSuccess,
  updateReimbursementTypeFail,
  addReimbursementTypeSuccess,
  addReimbursementTypeFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveReimbursementTypeApi,
  getReimbursementTypeApi,
  updateReimbursementTypeApi,
  deleteReimbursementTypeApi,
  addNewReimbursementTypeApi
} from "../../helpers/backend_helper";

function* getReimbursementType({ payload: reimbursementType }) {
  
  try {
    const response = yield call(getReimbursementTypeApi, reimbursementType);
    yield put(getReimbursementTypeSuccess(GET_REIMBURSEMENTTYPE, response.data));
  } catch (error) {
    yield put(getReimbursementTypeFail(GET_REIMBURSEMENTTYPE, error));
  }
}

function* onUpdateReimbursementType({ payload: reimbursementType }) {
  try {
    if (reimbursementType.setApprove) {
      const response = yield call(approveReimbursementTypeApi, reimbursementType);
      yield put(updateReimbursementTypeSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateReimbursementTypeApi, reimbursementType);
      yield put(updateReimbursementTypeSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateReimbursementTypeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteReimbursementType({ payload: reimbursementType }) {
  try {
    const response = yield call(deleteReimbursementTypeApi, reimbursementType);
    yield put(deleteReimbursementTypeSuccess({ reimbursementType, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteReimbursementTypeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewReimbursementType({ payload: reimbursementType }) {
  try {
    const response = yield call(addNewReimbursementTypeApi, reimbursementType);
    yield put(addReimbursementTypeSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addReimbursementTypeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetReimbursementType() {
  yield takeEvery(GET_REIMBURSEMENTTYPE, getReimbursementType);
}

export function* watchUpdateReimbursementType() {
  yield takeEvery(UPDATE_REIMBURSEMENTTYPE, onUpdateReimbursementType);
}

export function* watchDeleteReimbursementType() {
  yield takeEvery(DELETE_REIMBURSEMENTTYPE, onDeleteReimbursementType);
}

export function* watchAddNewReimbursementType() {
  yield takeEvery(ADD_NEW_REIMBURSEMENTTYPE, onAddNewReimbursementType);
}

function* reimbursementTypeSaga() {
  yield all([
    fork(watchGetReimbursementType),
    fork(watchDeleteReimbursementType),
    fork(watchUpdateReimbursementType),
    fork(watchAddNewReimbursementType)
  ]);
}

export default reimbursementTypeSaga;
